
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate/stores",
      function () {
        return require("private-next-pages/corporate/stores/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate/stores"])
      });
    }
  